import React, { useEffect, useMemo, useRef } from "react";
import StepperTabPanel from "@components/StepperTabs/StepperTabPanel";
import StepperTabs from "@components/StepperTabs/StepperTabs";
import { STEPPER_TYPE, type StepperTabsHandle } from "@components/StepperTabs/StepperTabs.types";
import type { ReviewFalProps } from "@features/vessel-call/vessel-call-status/VesselCallDetails/ImoFalReview/types";
import { useTranslation } from "react-i18next";
import { getImoFalPreviewData } from "./ImoFalReview/ImoFALPreview.utils";

interface ImoFALPreviewProps extends ReviewFalProps {}

const ImoFALPreview: React.FC<ImoFALPreviewProps> = ({
  vesselCallDetails,
  vesselRegisterDetails,
}) => {
  const stepperTabsRef = useRef<StepperTabsHandle>(null);
  const { steps, components, testIds } = useMemo(() => getImoFalPreviewData(), []);
  const { t } = useTranslation();

  useEffect(() => {
    if (stepperTabsRef.current?.getActiveStepperTab?.() === undefined) {
      stepperTabsRef.current?.setStepperTab?.(0);
    }
  }, []);

  return (
    <div className="w-full overflow-x-auto flex flex-col box-border">
      <StepperTabs
        ref={stepperTabsRef}
        testId={testIds.tabs}
        stepperType={STEPPER_TYPE.HORIZONTAL}
        isTypeChangeable={false}
      >
        {steps.map((s, idx) => {
          const Comp = components[idx];
          return (
            <StepperTabPanel key={s.path} label={t(s.label)}>
              <div
                className="min-w-full flex flex-col bg-white p-4 gap-4 min-w-900px"
                data-testid={testIds.panel(idx)}
              >
                <Comp
                  vesselCallDetails={vesselCallDetails}
                  vesselRegisterDetails={vesselRegisterDetails}
                />
              </div>
            </StepperTabPanel>
          );
        })}
      </StepperTabs>
    </div>
  );
};

export default ImoFALPreview;
